"use client";

import { useEffect } from "react";
import { ensureOpenReplayTrackerStarted } from "@/src/utils/openreplay";

export default function OpenReplayProvider() {
  useEffect(() => {
    void ensureOpenReplayTrackerStarted();
  }, []);

  return null;
}
